'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Requests = require('utils/requests');
var Strings = require('utils/strings');

var ChartsAndroidFix = require('utils/charts/charts_android_fix');
var ChartsExport = require('utils/charts/charts_export');

// Bar chart plotter adapted from http://dygraphs.com/tests/plotters.html

var lightenColor = function (colorStr) {
    var color = Dygraph.toRGB_(colorStr) || Dygraph.toRGB_(colorStr[0]);
    color.r = Math.floor((255 + color.r) / 2);
    color.g = Math.floor((255 + color.g) / 2);
    color.b = Math.floor((255 + color.b) / 2);
    return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
};

var getBarChartPlotter = function (replacementIndex) {
    return function (e) {
        var ctx = e.drawingContext;
        var points = e.points;
        var y_bottom = e.dygraph.toDomYCoord(0);

        // Find the minimum separation between x-values.
        // This determines the bar width.
        var min_sep = Infinity;
        for (var i = 1; i < points.length; i++) {
            var sep = points[i].canvasx - points[i - 1].canvasx;
            if (sep < min_sep) min_sep = sep;
        }
        var bar_width = Math.floor((2.0 / 3) * min_sep);

        // Do the actual plotting.
        for (var i = 0; i < points.length; i++) {
            var p = points[i];
            var center_x = p.canvasx;

            // use highlight color for last bar and bars that contain
            // device replacement events ..
            ctx.fillStyle = 'rgb(204, 204, 75)';
            if (i != points.length - 1 && replacementIndex[i] !== true) {
                // .. otherwise use 'lighter' color
                ctx.fillStyle = lightenColor(e.color);
            }

            ctx.fillRect(center_x - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy);

            ctx.strokeRect(center_x - bar_width / 2, p.canvasy, bar_width, y_bottom - p.canvasy);
        }
    };
};

var MeterView = Marionette.ItemView.extend({
    template: require('components/devices/templates/meter/meter'),

    events: {
        'click .js-remove': 'removeTile',
        'click .js-time-select': 'selectTime',
        'click .js-export-csv': 'exportCSV',
        'click .js-eop-mode-select': 'selectEOPmode',
        'click .js-export-eop-csv': 'exportEOPCSV',
    },

    rawData: {},

    initialize: function (options) {
        var self = this;

        this.controller = options.controller;

        this.chartDataCache = {};
        this.chartRefCache = [];

        this.seriesInfo = {};

        this.availableMeterValues = [];

        this.selectedMeterValues = [];
        this.selectedMeterGraphs = [];

        this.configuration = AppState.selectMeterValues(this.model.id);

        var timeHour = moment().utc().startOf('hour').unix();
        var timeDay = moment().utc().startOf('day').unix();
        var timeWeek = moment().utc().startOf('isoWeek').unix();
        var timeMonth = moment().utc().startOf('month').unix();

        this.timeConfiguration = {
            hour: {
                start: timeHour - 2 * 24 * (60 * 60), // last 2 days
                end: timeHour - 1,
                res: 60,
                display: i18n.TR('Stunden'),
            },
            day: {
                start: timeDay - 2 * 30 * (24 * 60 * 60), // last 2 months
                end: timeDay - 1,
                res: 24 * 60,
                display: i18n.TR('Tage'),
            },
            week: {
                start: timeWeek - 52 * (7 * 24 * 60 * 60), // last year
                end: timeWeek - 1,
                res: 7 * 24 * 60,
                display: i18n.TR('Wochen'),
            },
            month: {
                start: timeMonth - 3 * 12 * (30 * 24 * 60 * 60), // last 3 years
                end: timeMonth - 1,
                res: 24 * 60,
                display: i18n.TR('Monate'),
                timeWindow: 'month',
            },
        };

        this.eopModeConfiguration = {
            eop: {
                display: i18n.TR('Zählerstand'),
            },
            consumption: {
                display: i18n.TR('Verbrauch'),
            },
            year: {
                display: i18n.TR('12-Monatsverbrauch'),
            },
        };

        // determine all available metering values
        var modelData = this.model.attributes.data || {};
        _.each(options.values.models, function (v) {
            var attr = v.attributes;
            var addr = attr.nr;
            var isUnitFixed = attr.is_unit_fixed && attr.display_unit;
            var data = modelData['MBR_' + addr] || '--';
            var unit = attr.unit || '';

            var meterValueWhitelist = [
                6506, 6510, 6514, 6518, 6523, 6527, 6590, 6659, 7006, 7010, 7014, 7018, 7023, 7027, 7090, 7159, 7506,
                7510, 7514, 7518, 7523, 7527, 7590, 7659,
            ];

            if (_.contains(meterValueWhitelist, addr) && v.attributes.type == 'MBR') {
                if (data != '--') {
                    if (unit.startsWith('!')) {
                        v.attributes.unit = unit.substring(1);
                    } else {
                        // adapt display units if required
                        if (!isUnitFixed) {
                            if (unit.startsWith('W')) {
                                unit = unit.replace('W', 'kW');
                                data = data / 1000;
                            }
                            if (unit.startsWith('ml')) {
                                unit = unit.replace('ml', 'm³');
                                data = data / 1000000;
                            }
                            if (unit.startsWith('°C')) {
                                data = data / 10;
                            }
                        } else {
                            var unitData = Misc.getValueDisplayInfos(
                                data,
                                attr.type + '_' + attr.nr,
                                attr.format,
                                attr.unit,
                                attr.display_unit,
                                attr.is_unit_fixed
                            );
                            data = unitData.value;
                            unit = unitData.unit;
                        }
                    }
                }
                self.availableMeterValues.push({
                    type: 'value',
                    index: self.availableMeterValues.length,
                    spec: v,
                    data: data,
                    unit: data != '--' ? unit : '',
                });
                // HACK: improve "WMZ Arbeit" / "WMZ Volumen" detection
                if (addr % 500 == 10) {
                    self.availableMeterValues.push({
                        type: 'graph',
                        spec: v,
                        data: data,
                        time: 'hour',
                        display: self.timeConfiguration['hour'].display,
                    });
                }
                if (addr % 500 == 18) {
                    self.availableMeterValues.push({
                        type: 'g-eop_table',
                        time: 'month',
                        spec: {
                            attributes: {
                                name: i18n.TR('Monatswerte'),
                                nr: 6518,
                            },
                            is_default_hidden: false,
                        },
                        mode: 'eop',
                        display: self.eopModeConfiguration['eop'].display,
                    });
                    self.availableMeterValues.push({
                        type: 'graph',
                        spec: v,
                        data: data,
                        time: 'hour',
                        display: self.timeConfiguration['hour'].display,
                    });

                    var now = moment().utc();

                    var fiveYearsAgo = now.startOf('month').unix() - 5 * 12 * (30 * 24 * 60 * 60);
                    var deviceRegistration = self.model.get('registered')
                        ? moment(self.model.get('registered'), 'YYYY-MM-DD').startOf('month').utc().unix()
                        : 0;

                    var rawDataRequest = App.request(
                        'charts:meter:data:raw',
                        self.model.id,
                        Math.max(fiveYearsAgo, deviceRegistration),
                        now.utc().unix(),
                        24 * 60,
                        'MBR_6518'
                    );
                    var eopInfoRequest = App.request('meter:eop_infos', self.model.id);

                    $.when(rawDataRequest, eopInfoRequest).done(function (rawData, eopInfo) {
                        if (rawData || eopInfo) {
                            self.rawEopData = rawData || {};
                            self.rawEopData.info = eopInfo || [];

                            self.render();
                        }
                    });
                }
            }
        });

        if (this.availableMeterValues.length == 0) {
            // no meter values available -> no further initialization
            return;
        }

        // determine meter values to show
        if (this.configuration == undefined) {
            this.configuration = [];
            // -> show all available values
            _.each(this.availableMeterValues, function (v) {
                if (v.is_default_hidden) {
                    return;
                }

                if (v.type == 'value') {
                    self.selectedMeterValues.push(v);
                } else {
                    if (v.spec.attributes.nr != 6510) {
                        self.selectedMeterValues.push(v);
                        self.selectedMeterGraphs.push(v);
                    }
                }
                self.configuration.push({
                    type: v.type,
                    addr: v.spec.attributes.nr,
                    is_unit_fixed: v.spec.attributes.is_unit_fixed,
                    display_unit: v.spec.attributes.display_unit,
                });
            });
        } else {
            // -> filter available values by user selection
            var updatedConfiguration = [];
            _.each(this.configuration, function (c) {
                var available = _.find(self.availableMeterValues, function (v) {
                    return v.type == c.type && (v.spec.attributes.nr == c.addr || v.type == 'g-eop_table');
                });
                if (available) {
                    self.selectedMeterValues.push(available);
                    if (available.type != 'value') {
                        self.selectedMeterGraphs.push(available);
                    }
                    updatedConfiguration.push(c);
                }
            });
            this.configuration = updatedConfiguration;
        }
    },

    setPermission: function (permissions) {
        // view does not contain "writable" content
        // -> no 'read-only' mode -> do nothing
    },

    serializeEopData: function () {
        if (!this.rawEopData) {
            // data not available
            return;
        }
        var self = this;

        // prepare EOP table data

        // determine available years ..
        var eopYears = [];
        // .. based on EOP data
        _.each(this.rawEopData.info || [], function (v) {
            eopYears.push(parseInt(v.year));
        });
        // .. based on time series data
        _.each(this.rawEopData.values || [], function (v) {
            if (v[1] == undefined) {
                return;
            }

            eopYears.push(
                moment
                    .unix(v[0] + 15 * 24 * 60 * 60)
                    .utc()
                    .year()
            ); // adapt raw data "time alignment"
        });

        eopYears = _.uniq(eopYears).sort().reverse().slice(0, 6);
        if (eopYears.length == 0) {
            return;
        }

        var eopData = [
            {
                month: i18n.TR('Jan'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Feb'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Mär'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Apr'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Mai'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Jun'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Jul'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Aug'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Sep'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Okt'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Nov'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
            {
                month: i18n.TR('Dez'),
                data: Array(eopYears.length).fill(undefined),
                consumption: Array(eopYears.length).fill(undefined),
                twelveMonth: Array(eopYears.length).fill(undefined),
            },
        ];

        var eopInfoTypeValue = 1;
        var eopInfoTypeReplacement = 2;

        var getMonth = function (date, type) {
            var result = function (d, m) {
                return {
                    yDelta: d,
                    month: m,
                };
            };

            if (type == eopInfoTypeReplacement) {
                // do not consider any year delta for meter replacements
                // use month and year "as is"
                return result(0, parseInt(date.substring(0, 2)) - 1);
            }

            // explicit white list -> filters strange EOP timestamps like 15.04.
            return (
                {
                    101: result(1, 11),
                    201: result(0, 0),
                    301: result(0, 1),
                    401: result(0, 2),
                    501: result(0, 3),
                    601: result(0, 4),
                    701: result(0, 5),
                    801: result(0, 6),
                    901: result(0, 7),
                    1001: result(0, 8),
                    1101: result(0, 9),
                    1201: result(0, 10),

                    131: result(0, 0),
                    228: result(0, 1),
                    229: result(0, 1),
                    331: result(0, 2),
                    430: result(0, 3),
                    531: result(0, 4),
                    630: result(0, 5),
                    731: result(0, 6),
                    831: result(0, 7),
                    930: result(0, 8),
                    1031: result(0, 9),
                    1130: result(0, 10),
                    1231: result(0, 11),
                }[parseInt(date)] || result(-1, -1)
            );
        };

        var getDisplayValue = function (counter, unit) {
            var unitLookup = {
                1281: 'kWh',
                1536: 'kWh',
                1792: 'MWh',
            };

            if (unitLookup[unit] == undefined) {
                return;
            }

            switch (unit) {
                case 1281:
                    counter = (counter / 1000.0).toFixed(1);
                    break;
                case 1792:
                    counter = (counter / 1000.0).toFixed(2);
                    break;
            }

            return counter + ' ' + unitLookup[unit];
        };

        var getRawKWHValue = function (counter, unit) {
            var unitLookup = {
                1281: 'kWh',
                1536: 'kWh',
                1792: 'MWh',
            };

            if (unitLookup[unit] == undefined) {
                return;
            }

            switch (unit) {
                case 1281:
                    return counter / 1000.0;
                case 1792:
                    return counter * 1.0;
            }

            return counter;
        };

        _.each(this.rawEopData.values || [], function (v) {
            if (v[1] == undefined) {
                return;
            }

            var tsTime = moment.unix(v[0] + 15 * 24 * 60 * 60).utc(); // adapt raw data "time alignment"

            var yIdx = _.indexOf(eopYears, tsTime.year());
            var mIdx = tsTime.month();

            if (yIdx != -1) {
                var value = Math.trunc(v[1] / 1000);
                eopData[mIdx].data[yIdx] = {
                    value: value + ' kWh',
                    raw: value,
                    status: {
                        icon: '~',
                    },
                };
            }
        });

        // use "last seen" of current device as base for current value
        // -> This might override a raw value, but that is ok:
        //    The raw value is aggregated using "MAX", the current value is correct if
        //    the meter device was replaced this month.
        var latestMeterValue = (self.model.attributes.data || {})['MBR_6518'] || 0;
        if (latestMeterValue > 0) {
            var lastSeen = moment(self.model.attributes.last_seen);

            var yIdx = _.indexOf(eopYears, lastSeen.year());
            var mIdx = lastSeen.month();

            if (yIdx != -1) {
                var value = Math.trunc(latestMeterValue / 1000);
                eopData[mIdx].data[yIdx] = {
                    value: value + ' kWh',
                    raw: value,
                    status: {
                        icon: '~',
                    },
                };
            }
        }

        _.each(this.rawEopData.info || [], function (e) {
            if (e.type == eopInfoTypeReplacement) {
                return;
            }

            var mInfo = getMonth(e.date, e.type);

            var yIdx = _.indexOf(eopYears, parseInt(e.year) - mInfo.yDelta);
            var mIdx = mInfo.month;

            if (yIdx != -1 && mIdx != -1) {
                eopData[mIdx].data[yIdx] = {
                    value: getDisplayValue(e.value1, e.value2),
                    raw: getRawKWHValue(e.value1, e.value2),
                };
            }
        });

        _.each(this.rawEopData.info || [], function (e) {
            if (e.type == eopInfoTypeValue) {
                return;
            }

            var mInfo = getMonth(e.date, e.type);

            var yIdx = _.indexOf(eopYears, parseInt(e.year) - mInfo.yDelta);
            var mIdx = mInfo.month;

            if (yIdx != -1 && mIdx != -1) {
                var data = eopData[mIdx].data[yIdx];
                if (data != undefined) {
                    data.status = {
                        icon: data.status ? data.status.icon : undefined,
                        inCounter: e.value2,
                        outCounter: e.value1,
                        replaced: true,
                    };
                }
            }
        });

        _.each(eopData, function (m, i) {
            _.each(m.data, function (y, j) {
                var current = y;
                var previous = undefined;

                if (i != 0) {
                    // previous month - same year
                    previous = eopData[i - 1].data[j];
                } else {
                    // december - previous year
                    previous = eopData[11].data[j + 1];
                }

                if (current != undefined && previous != undefined) {
                    var delta = 0;
                    if (current.status != undefined) {
                        delta = (current.status.outCounter || 0) - (current.status.inCounter || 0);
                    }

                    if (current.raw - previous.raw + delta >= 0) {
                        m.consumption[j] = {
                            value: Math.round(current.raw - previous.raw + delta) + ' kWh',
                            raw: current.raw - previous.raw + delta,
                            status: {
                                icon: undefined,
                            },
                        };

                        if (current.status != undefined && current.status.outCounter != undefined) {
                            m.consumption[j].status.icon = 'exchange';
                        } else if (current.status != undefined || previous.status != undefined) {
                            m.consumption[j].status.icon = '~';
                        }
                    }
                }
            });
        });

        _.each(eopData, function (m, i) {
            _.each(m.consumption, function (y, j) {
                var current = y;
                var previous = eopData[i].consumption[j + 1];

                if (current != undefined && previous != undefined) {
                    var percent = previous.raw == 0 ? 0 : ((current.raw - previous.raw) * 100.0) / previous.raw;

                    var trendClass = percent < 0 ? 'success' : 'error';
                    var trendIcon = '';

                    if (percent <= -100) {
                        trendIcon = '&#x2B87';
                    } else if (percent <= -50) {
                        trendIcon = '&#x2193';
                    } else if (percent <= -10) {
                        trendIcon = '&#x2B69';
                    } else if (percent >= 100) {
                        trendIcon = '&#x2B85';
                    } else if (percent >= 50) {
                        trendIcon = '&#x2191';
                    } else if (percent >= 10) {
                        trendIcon = '&#x2B66';
                    }

                    if (trendIcon != '') {
                        m.consumption[j].status.trendIcon = trendIcon;
                        m.consumption[j].status.trendClass = trendClass;
                    }
                }
            });
        });

        _.each(eopData, function (m, i) {
            _.each(m.consumption, function (y, j) {
                var current = y;

                // add current value to the next 12 values
                var mIdx = i;
                var yIdx = j;
                var count = 0;

                while (count < 12 && yIdx >= 0 && yIdx < eopYears.length) {
                    var sumInfo = eopData[mIdx].twelveMonth[yIdx] || {
                        sum: 0,
                        count: 0,
                        status: {},
                    };

                    if (current != undefined && current.raw != undefined) {
                        // update consumption sum
                        sumInfo.sum += current.raw;
                        sumInfo.value = Math.round(sumInfo.sum) + ' kWh';
                        sumInfo.count += 1;
                        if (current.status.icon != undefined) {
                            sumInfo.status.icon = '~';
                        }

                        if (Requests.getSubdomain(window.location.host) == 'waerme-hamburg') {
                            var hwd = (self.model.attributes.data || {})['SCR_1'] || 0;
                            if (hwd > 0) {
                                sumInfo.ausnutzung = ((sumInfo.sum * 1000) / hwd).toFixed(1);
                            }
                        }
                    }

                    eopData[mIdx].twelveMonth[yIdx] = sumInfo;

                    // move to next field
                    if (mIdx != 11) {
                        mIdx += 1;
                    } else {
                        mIdx = 0;
                        yIdx -= 1;
                    }
                    count++;
                }
            });
        });

        _.each(eopData, function (m, i) {
            _.each(m.twelveMonth, function (y, j) {
                var current = y;
                var previous = eopData[i].twelveMonth[j + 1];

                if (current != undefined && previous != undefined) {
                    if (current.count != 12 || previous.count != 12) {
                        return;
                    }

                    var percent = previous.sum == 0 ? 0 : ((current.sum - previous.sum) * 100.0) / previous.sum;

                    var trendClass = percent < 0 ? 'success' : 'error';
                    var trendIcon = '';

                    if (percent <= -100) {
                        trendIcon = '&#x2B87';
                    } else if (percent <= -50) {
                        trendIcon = '&#x2193';
                    } else if (percent <= -10) {
                        trendIcon = '&#x2B69';
                    } else if (percent >= 100) {
                        trendIcon = '&#x2B85';
                    } else if (percent >= 50) {
                        trendIcon = '&#x2191';
                    } else if (percent >= 10) {
                        trendIcon = '&#x2B66';
                    }

                    if (trendIcon != '') {
                        m.twelveMonth[j].status.trendIcon = trendIcon;
                        m.twelveMonth[j].status.trendClass = trendClass;
                    }
                }
            });
        });

        return {
            years: eopYears,
            data: eopData,
        };
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.availableMeterValues = this.availableMeterValues;

        data.selectedMeterValues = _.filter(this.selectedMeterValues, function (v) {
            return v.type == 'value';
        });
        data.selectedMeterGraphs = this.selectedMeterGraphs;

        data.eop = this.serializeEopData();

        return data;
    },

    onAttach: function () {
        // no values available -> hide breadcrumb action button
        Misc.setVisible('a.js-action', this.availableMeterValues.length > 0);

        // register resize handler
        var self = this;
        window.meterChartResizeHandler = function () {
            _.each(self.chartRefCache, function (c) {
                c.resize();
            });
        };
        window.resizefunc.push('meterChartResizeHandler');
    },

    onBeforeDestroy: function () {
        // remove resize handler
        var handlerFuncIndex = window.resizefunc.indexOf('meterChartResizeHandler');
        if (handlerFuncIndex != -1) {
            window.resizefunc.splice(handlerFuncIndex, 1);
            window.meterChartResizeHandler = undefined;
        }
        // destroy all chart objects
        _.each(this.chartRefCache, function (c) {
            c.destroy();
        });
        this.chartRefCache = [];
    },

    onRender: function () {
        this.initializeCharts();
    },

    updateChart: function (data) {
        var chartId = data.chartId;
        var chart = document.getElementById('chart-' + chartId);
        if (!chart) {
            // chart not shown yet
            return;
        }

        // show selector - if no data is available, it might still be
        // possible to switch to another time frame
        $('#chart-time-selector-' + chartId).removeClass('invisible');

        // chart data not available
        var btnExport = $('.js-btn-export-csv[data-chart="' + chartId + '"]');
        if (data.failed == true) {
            btnExport.prop('disabled', true);
            chart.innerHTML =
                '<div class="alert alert-danger m-t-20">' + i18n.TR('Werte konnten nicht geladen werden.') + '</div>';
            return;
        }
        if (data.values.length == 0) {
            btnExport.prop('disabled', true);
            chart.innerHTML =
                '<div class="alert alert-info m-t-20">' +
                i18n.TR('Zu wenige Werte für den ausgewählten Zeitbereich.') +
                '</div>';
            return;
        }
        btnExport.prop('disabled', false);

        // determine min and max data for charting
        // -> the default settings would not show the complete first/last bar
        var delta = this.timeConfiguration[this.selectedMeterGraphs[chartId].time].res * 0.7;

        var minDate = moment(data.values[0][0]).add(-delta, 'seconds').toDate();
        var maxDate = moment(data.values[data.values.length - 1][0])
            .add(delta, 'seconds')
            .toDate();

        var valueRange = [
            _.min(data.values, function (a) {
                return a[1];
            })[1],
            _.max(data.values, function (a) {
                return a[1];
            })[1],
        ];

        var margin = 1.1;

        valueRange = [
            valueRange[0] == 0 ? 0 : valueRange[0] * (0.5 + margin / 2) + valueRange[1] * (0.5 - margin / 2),
            valueRange[1] * (0.5 + margin / 2) + valueRange[0] * (0.5 - margin / 2),
        ];

        var androidFix = new ChartsAndroidFix({ noView: true });
        var seriesInfo = {
            name: i18n.TR('Verbrauch'),
            label: i18n.TR('Verbrauch'),
            unit: data.unit || 'Wh',
            type: data.type || 'MBR',
            format: '',
            is_unit_fixed: data.displayUnit !== undefined,
            display_unit: data.displayUnit,
        };
        this.seriesInfo[chartId] = [seriesInfo];

        // initialize/update graph
        var d = new Dygraph(chart, data.values, {
            animatedZooms: true,
            includeZero: true,

            labels: ['x', i18n.TR('Verbrauch')],
            plotter: getBarChartPlotter(data.replacementIndex),
            dateWindow: [minDate, maxDate],
            color: [AppState.style[1]],
            valueRange: valueRange,
            seriesInfo: this.seriesInfo[chartId],

            axes: {
                x: {
                    drawGrid: false,
                    axisLabelFormatter: function (d, gran, opts) {
                        var hrs = d.getHours();
                        var mins = d.getMinutes();
                        var secs = d.getSeconds();

                        switch (gran) {
                            case Dygraph.DAILY:
                            case Dygraph.TWO_DAILY:
                            case Dygraph.WEEKLY:
                                // show day and month
                                return '' + d.getDate() + ' ' + Consts.MonthNamesShort[d.getMonth()];
                            case Dygraph.MONTHLY:
                            case Dygraph.QUARTERLY:
                            case Dygraph.BIANNUAL:
                            case Dygraph.ANNUAL:
                                // show month and year
                                return Consts.MonthNamesShort[d.getMonth()] + ' ' + d.getFullYear();
                            case Dygraph.DECADAL:
                            case Dygraph.CENTENNIAL:
                                // show year only
                                return '' + d.getFullYear();
                        }

                        // default: format as time - except for midnight
                        if (hrs == 0 && mins == 0 && secs == 0) {
                            return '' + d.getDate() + ' ' + Consts.MonthNamesShort[d.getMonth()];
                        }
                        return moment(d).format('HH:mm');
                    },
                },
                y: {
                    axisLabelWidth: 70,
                    axisLabelFormatter: function (number) {
                        if (seriesInfo.is_unit_fixed) {
                            var valueUnit = Misc.getValueDisplayInfos(
                                number,
                                data.fields,
                                seriesInfo.format,
                                seriesInfo.unit,
                                seriesInfo.display_unit,
                                seriesInfo.is_unit_fixed
                            );
                            return valueUnit.value + ' ' + valueUnit.unit;
                        }
                        var adjusted = Strings.adjustUnits(number, data.displayUnit || 'Wh');
                        if (adjusted.value == 0) {
                            return '0';
                        }
                        return adjusted.value + '&nbsp;' + adjusted.unit;
                    },
                },
            },
            zoomCallback: function (min, max, yRanges) {
                if (d.dateWindow_ == null) {
                    d.updateOptions({
                        dateWindow: [minDate, maxDate],
                    });
                }
            },
            drawCallback: function () {
                androidFix.afterDraw(d);
            },
        });
        this.chartRefCache.push(d);

        d.trovisContext = {};

        // highlight last point in chart -> trigger legend
        d.setSelection(data.values.length - 1);
    },

    initializeCharts: function () {
        var self = this;

        _.each(this.selectedMeterGraphs, function (g, id) {
            var cacheKey = g.time + '_' + g.spec.attributes.nr;
            if (self.chartDataCache[cacheKey] === undefined) {
                // not cached -> fetch data
                var dataRequest = App.request(
                    'charts:meter:data',
                    self.model.id,
                    self.timeConfiguration[g.time].start,
                    self.timeConfiguration[g.time].end,
                    self.timeConfiguration[g.time].res,
                    'MBR_' + g.spec.attributes.nr,
                    self.timeConfiguration[g.time].timeWindow,
                    undefined,
                    id
                );
            } else {
                // cached! -> resolve with available information
                var dataRequest = $.Deferred();
                dataRequest.resolve(self.chartDataCache[cacheKey]);
            }
            $.when(dataRequest).done(function (data) {
                // write successfully fetched data into cache
                if (data.failed == false && data.values.length >= 2 && !data.is_cached) {
                    data.is_cached = true;

                    // determine time distance between values
                    var timeDelta = data.values[1][0] - data.values[0][0];
                    var currentEntryTime = -1; // will be determined while postprocessing

                    // data postprocessing ..
                    // .. determine value for first timestamp
                    var baseValue = data.values[0][1];
                    // .. remove first value (can not calculate difference)
                    // cache prepared data
                    self.chartDataCache[cacheKey] = data;

                    // process replacement events
                    data.replacementIndex = Misc.selectWhere(data.values, undefined, function (e) {
                        var start = e[0].getTime();
                        var end = start + timeDelta;

                        var events = _.filter(data.replaced, function (replacementTime) {
                            return replacementTime > start && replacementTime < end;
                        });

                        return events.length != 0;
                    });
                }

                if (g.type !== 'graph') {
                    return;
                }

                data.chartId = id;

                data.type = g.spec.get('type');
                data.format = g.spec.get('format');
                data.unit = g.spec.get('unit');
                data.displayUnit = g.spec.get('is_unit_fixed') && g.spec.get('display_unit');

                self.rawData[data.chartId] = Misc.selectWhere(data.values, undefined, function (a) {
                    var row = a.slice();
                    row[0] = new Date(row[0]).getTime() / 1000;
                    return row;
                });

                self.updateChart(data);
            });
        });
    },

    updateSelection: function (selected) {
        this.selectedMeterValues = selected;
        this.selectedMeterGraphs = _.filter(this.selectedMeterValues, function (v) {
            return v.type != 'value';
        });
        this.render();
    },

    addTile: function () {
        var self = this;

        var columns = [
            { name: i18n.TR('Analyse'), entries: [] },
            { name: i18n.TR('Werte'), entries: [] },
        ];

        var selected = this.selectedMeterValues;
        var available = this.availableMeterValues;

        // prepare column information
        _.each(available, function (v, index) {
            var list = columns[v.type != 'value' ? 0 : 1].entries;
            list.push({
                name: i18n.DATAPOINT_BY_ID(v.spec.attributes.device, v.spec.attributes.name),
                index: index,
                is_selected:
                    _.find(selected, function (e) {
                        return e.type == v.type && v.spec.attributes.nr == e.spec.attributes.nr;
                    }) != undefined,
            });
        });

        this.controller.showMeterValueSelectionDialog({
            title: i18n.TR('Zählerwerte auswählen'),

            titleAvailableItems: i18n.TR('Verfügbar'),
            titleChosenItems: i18n.TR('Dashboard'),

            columns: columns,
            available: available,

            save_cb: function (valueIndex) {
                var selection = [];
                var configuration = [];

                _.each(valueIndex, function (s) {
                    var v = available[s];
                    selection.push(v);
                    configuration.push({
                        type: v.type,
                        addr: v.spec.attributes.nr,
                    });
                });

                self.updateSelection(selection);

                self.configuration = configuration;
                AppState.saveSelectedMeterValues(self.model.id, self.configuration);
            },
        });
    },

    removeTile: function (e) {
        e.preventDefault();

        var type = e.currentTarget.id.substring(8, 9);
        var index = e.currentTarget.id.substring(10);

        var count = 0;
        for (var i = 0; i < this.selectedMeterValues.length; ++i) {
            if (this.selectedMeterValues[i].type.startsWith(type)) {
                if (count == index) {
                    index = i;
                    break;
                }
                count += 1;
            }
        }

        // remove tile
        this.selectedMeterValues.splice(index, 1);
        this.updateSelection(this.selectedMeterValues);

        // update and save custom configuration
        this.configuration.splice(index, 1);
        AppState.saveSelectedMeterValues(this.model.id, this.configuration);
    },

    selectTime: function (e) {
        e.preventDefault();

        var params = e.currentTarget.id.substring(5).split('-');
        var g = this.selectedMeterGraphs[params[0]];

        g.time = params[1];
        (g.display = this.timeConfiguration[params[1]].display), this.render();
    },

    exportCSV: function (e) {
        var chartIdx = $(e.currentTarget).attr('data-chart');
        var content = ChartsExport.BuildCSVContent({
            rawData: this.rawData[chartIdx],
            selectedSeries: this.seriesInfo[chartIdx],
        });

        ChartsExport.CreateDownloadLink(content, 'meter.csv', 'text/csv;charset=utf-8;', undefined, function () {});
    },

    selectEOPmode: function (e) {
        e.preventDefault();

        var params = e.currentTarget.id.substring(5).split('-');
        var g = this.selectedMeterGraphs[params[0]];

        g.mode = params[1];
        (g.display = this.eopModeConfiguration[params[1]].display), this.render();
    },

    exportEOPCSV: function (e) {
        var g = this.selectedMeterGraphs[e.currentTarget.id.split('-')[2]];

        var timeStamp = moment().year() + '-' + (moment().month() + 1 + '').padStart(2, '0');

        var fileName = this.model.get('name') + ' - ' + g.display + ' - ' + timeStamp + '.csv';
        var eopData = this.serializeEopData();

        var content = '';

        // CSV header
        content += ';';
        _.each(eopData.years, function (y, i) {
            if (g.mode == 'year' && i == eopData.years.length - 1) {
                return;
            }
            content += y + ';';

            if (i != eopData.years.length - 1) {
                content += ';';
            }
        });
        content += '\n';

        // CSV data
        _.each(eopData.data, function (m) {
            content += m.month;
            switch (g.mode) {
                case 'eop': {
                    _.each(m.data, function (d) {
                        if (d) {
                            content += ';' + d.value + ';';

                            var status = d.status || {};
                            if (status.icon == '~') {
                                content += i18n.TR('letzter übertragener Zählerstand');
                            } else {
                                content += i18n.TR('Monatswert');
                            }
                        } else {
                            content += ';;';
                        }
                    });
                    break;
                }
                case 'consumption': {
                    _.each(m.consumption, function (d) {
                        if (d) {
                            content += ';' + d.value + ';';

                            var status = d.status || {};
                            if (status.icon) {
                                content += i18n.TR('basierend auf letztem übertragenen Zählerstand');
                            }
                        } else {
                            content += ';;';
                        }
                    });
                    break;
                }
                case 'year': {
                    _.each(m.twelveMonth, function (d, i) {
                        if (i == eopData.years.length - 1) {
                            return;
                        }

                        if (d && d.count == 12) {
                            content += ';' + d.value + ';';

                            var status = d.status || {};
                            if (status.icon) {
                                content += i18n.TR('basierend auf letztem übertragenen Zählerstand');
                            }
                        } else {
                            content += ';;';
                        }
                    });
                    break;
                }
            }
            content += '\n';
        });

        ChartsExport.CreateDownloadLink(content, fileName, 'text/csv;charset=utf-8;', undefined, function () {});
    },
});

module.exports = MeterView;
